import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { LoginAPIResponse, UserInfo } from "../Types";
import * as md5 from "md5";

const AuthContextDefaultValues: {
  user: UserInfo | null;
  loading: boolean;
  logIn: (userName: string, password: string) => Promise<void>;
  logOut: () => Promise<void>;
} = {
  user: null,
  loading: false,
  logIn: async (userName: string, password: string) => {},
  logOut: async () => {},
};

export const AuthContext = createContext(AuthContextDefaultValues);

export const AuthContextProvider: React.FC<{}> = ({ children }) => {
  const [user, setUser] = useState<null | UserInfo>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const effect = async () => {
      // Check if we are logged in.
      setLoading(true);
      try {
        const result = await axios.get<UserInfo | null>("/vue_api/is_logged_in");

        if (result.data) {
          setUser(result.data);
        }
      } catch (e) {}
      setLoading(false);
    };
    effect();
  }, []);

  const logIn = async (userName: string, password: string) => {
    setLoading(true);

    const result = await axios.post<LoginAPIResponse>("/vue_api/log_in", {
      u: userName,
      p: md5(password),
    });
    setUser(result.data.user_info);
    setLoading(false);
  };

  const logOut = async () => {
    setLoading(true);

    try {
      await axios.get("/vue_api/log_out");
    } catch (e) {
      console.warn("log out error");
    }
    setUser(null);
    setLoading(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logIn, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};
